require('./bootstrap');

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '../sass/app.scss';
import SnackbarPlugin from './Plugins/snackbar';
import TodoPlugin from './Plugins/todo';

// Configure Vuetify
Vue.use(Vuetify);

// Install plugins - these are used in both legacy and Inertia pages
Vue.use(SnackbarPlugin);
Vue.use(TodoPlugin);

// Import Poppins font
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

const vuetifyOptions = {
    icons: {
        iconfont: 'fa',
    },
    theme: {
        themes: {
            light: {
                primary: '#4299e1',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FB8C00',
                background: '#f7fafc',
            },
        },
        options: {
            customProperties: true,
        },
    },
    typography: {
        fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    },
};

// Global mixins
Vue.mixin({
    methods: {
        formatCurrency(value) {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP'
            }).format(value);
        },
    },
});

// Check if this is an Inertia page
const inertiaEl = document.getElementById('app');
const isInertiaPage = inertiaEl && inertiaEl.dataset.page;

if (isInertiaPage) {
    // Initialize as Inertia app
    import('@inertiajs/inertia-vue').then(({ createInertiaApp }) => {
        import('@inertiajs/progress').then(({ InertiaProgress }) => {
            // Initialize Inertia Progress
            InertiaProgress.init({ 
                color: '#007bff',
                showSpinner: true,
            });

            // Create Inertia App
            createInertiaApp({
                title: (title) => title ? `Watermin : ${title}` : 'Watermin',
                resolve: (name) => import(`./Pages/${name}.vue`)
                    .then(module => module.default),
                setup({ el, app, props, plugin }) {
                    Vue.use(plugin);
                    
                    const vuetify = new Vuetify(vuetifyOptions);
                    
                    new Vue({
                        vuetify,
                        render: h => h(app, props),
                    }).$mount(el);
                },
            });
        });
    });
} else {
    // Legacy Vue initialization for login page only
    // Make Vue and Vuetify available globally for the login blade template
    window.Vue = Vue;
    window.Vuetify = Vuetify;

    Vue.config.devtools = true;
    Vue.config.productionTip = false;
}